var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCardBody',[_c('CDataTable',{attrs:{"items":_vm.items,"fields":_vm.fields,"items-per-page":20,"hover":"","sorter":"","pagination":""},scopedSlots:_vm._u([{key:"ردیف",fn:function(ref){
var item = ref.item;
return [_c('td',[_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(item.section_id))])])]}},{key:"نام",fn:function(ref){
var item = ref.item;
return [_c('td',[_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(item.name))])])]}},{key:"عملیات",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('td',{staticClass:"py-2"},[_c('CButton',{attrs:{"color":"primary","variant":"outline","square":"","size":"sm"},on:{"click":function($event){return _vm.goSectionRows(item)}}},[_vm._v("ویرایش چیدمان ")])],1)]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }